<template>
    <div class="suggest">
        <p-header title="提出修改建議" left-btn="完成" @onLeftBtn="send"/>
        <div class="title">
            提供店家正確資訊？
        </div>
        <div class="options">
            <div class="option">
                <input id="name" value="name" type="checkbox" v-model="selected">
                <label for="name">店家名稱</label>
            </div>
            <div class="option">
                <input id="address" value="address" type="checkbox" v-model="selected">
                <label for="address">地址</label>
            </div>
            <div class="option">
                <input id="phone" value="phone" type="checkbox" v-model="selected">
                <label for="phone">電話</label>
            </div>
            <div class="option">
                <input id="works" value="works" type="checkbox" v-model="selected">
                <label for="works">營業時間</label>
            </div>
            <div class="option">
                <input id="menu" value="menu" type="checkbox" v-model="selected">
                <label for="menu">菜單資訊</label>
            </div>
        </div>
        <div class="note">
            <span>詳細補充</span>
            <p-textarea v-model="note" placeholder="還有哪些建議呢？"></p-textarea>
        </div>
    </div>
</template>

<script>
    import Header from '../components/Header';
    import PTextarea from '../components/AutoHeighTextarea';
    import * as apis from '../../apis';
    import Swal from 'sweetalert2'

    export default {
        name: 'Suggest',
        components: {
            'p-header': Header,
            'p-textarea': PTextarea,
        },
        data() {
            return {
                selected: [],
                note: '',
            }
        },
        methods: {
            send() {
                if (!this.note && !this.selected.length) {
                    this.$router.back();
                    return;
                }

                let payload = {
                    id: this.$route.params.id,
                    params: {
                        options: this.selected,
                        content: this.note,
                    }
                };

                apis.sendShopSuggest(payload).then(() => {
                    Swal.fire({
                        title: '感謝您的建議',
                        text: '祝您有個美好的一天',
                        type: 'success',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        timer: 2000
                    }).then(() => {
                        this.$router.back();
                    })
                }).catch(err => {
                    this.display = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        margin: 15px 25px;
        color: #000000;
        font-size: 16px;
        font-weight: 600;
        text-align: left;
    }

    .options {
        margin: 0 15px;

        .option {
            display: flex;
            padding: 10px;
            box-sizing: border-box;

            label {
                flex: 1;
                text-align: left;
                color: #000000;
                font-size: 14px;
                line-height: 20px;
                position: relative;
            }
        }
    }

    .note {
        margin: 15px 15px;
        position: relative;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
        text-align: left;
        font-size: 14px;

        textarea {
            margin-top: 10px;
            min-height: 6em;
        }
    }

    .suggest {
        input[type=checkbox] {
            display: none;
        }

        input[type=checkbox] + label {
            cursor: pointer;

            &:before {
                position: absolute;
                content: '';
                width: 1em;
                height: 1em;
                border: solid 1px #9B9B9B;
                right: 0;
                top: 0;
                border-radius: 90px;
            }
        }

        input[type=checkbox]:checked + label {
            &:before {
                position: absolute;
                content: '';
                width: 1em;
                height: 1em;
                right: 0;
                top: 0;
                border-radius: 90px;
                background-color: #339933;
            }

            &:after {
                position: absolute;
                width: .6em;
                height: .3em;
                content: '';
                right: 3px;
                top: 3px;
                border-left: solid 2px #fff;
                border-bottom: solid 2px #fff;
                transform: rotate(-45deg);
            }
        }
    }
</style>
